<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="commission-flow" >
        <div class="header-box">
            <h4>{{ pageTitle }}</h4>
        </div>
        <div class="resp-hr"></div>
        <div class="detail-toolBar-resp">
            <lots-button size="mini" type="primary" v-if="showBtn.save" class="bigData-btn-commission-flow-save"
                @click="handleSave" :loading="saveLoading">
                保存
            </lots-button>
            <lots-button size="mini" type="primary" v-if="showBtn.submit" class="bigData-btn-commission-flow-submit"
                @click="handleSubmit" :loading="submitLoading">
                提交
            </lots-button>
        </div>
        <div class="resp-hr"></div>
        <div class="commission-flow-detail commission-info" v-loading="detailLoading">
            <collapse-infos ref="upholdHealder" :detailData="detailDataLocal" :collapse="COLLAPSE"
                :activeCollapses="activeCollapses" @change="handleInfosChange">
                <template v-slot:collapse-title-append="{ collapseItem }">
                    <span>{{ collapseItem.title }}</span>
                </template>
                <template v-slot:collapse-append="{ form, itemSetting, rIndex, collapseItem, dictData }">
                    <span v-if="itemSetting.prop === 'fileList'">
                        <div v-if="showBtn.editBtn" class="commission-flow-upload" @click.capture="handleUploadBtnClick">
                            <lots-upload-button ref="uploadRef" :text="'上传附件'" :bucket="'annto-lcrm'"
                                @callback="(data) => { upLoadData(form, itemSetting, data); }" >
                            </lots-upload-button>
                        </div>
                        <div class="file-infos">
                            <template v-if="form[itemSetting.prop]
                                && form[itemSetting.prop].length">
                                <div class="file-list" v-for="(item, index) in form[itemSetting.prop]"
                                    :key="index + item.fileName">
                                    <div class="file-name upload" :title="item.fileName">
                                        {{ `${index + 1}. ` }}
                                        <span class="file-link bigData-btn-commission-flow-preview" @click="handlePreview(item)">{{ item.fileName }}</span>
                                    </div>
                                    <div class="delete-btn">
                                        <el-button type="text" plain @click="handlePreview(item)" class="bigData-btn-commission-flow-preview">
                                            预览
                                        </el-button>
                                        <el-button type="text" plain @click="handleDownload(item)" class="bigData-btn-commission-flow-download">
                                            下载
                                        </el-button>
                                        <el-button type="text"
                                            v-if="showBtn.editBtn"
                                            plain
                                            @click="handleDeleteFile(form, itemSetting, index)" class="bigData-btn-commission-flow-delete">删除</el-button>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </span>
                    <div v-else-if="['todoContent', 'content'].includes(itemSetting.prop)" class="custom-textarea" :title="form[itemSetting.prop]">
                        {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                    </div>
                    <span v-else-if="itemSetting.prop === 'ownerName'" class="custom-span user-select-span"
                         :title="form[itemSetting.prop]" @click="openMeixin(detailDataLocal, 'owner')">
                        {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                    </span>
                    <span v-else-if="itemSetting.prop === 'approverName'" class="custom-span user-select-span"
                         :title="form[itemSetting.prop]" @click="openMeixin(detailDataLocal, 'approver')">
                        {{ form[itemSetting.prop] ? form[itemSetting.prop] : '--' }}
                    </span>
                    <span v-else-if="!itemSetting.optionsKey" class="custom-span" :title="form[itemSetting.prop]">
                        {{ (form[itemSetting.prop] || form[itemSetting.prop] === 0) ? form[itemSetting.prop] : '--' }}
                    </span>
                </template>
            </collapse-infos>

            <el-collapse v-if="detailDataLocal.fdId" class="contract-collapse detail-more-collapse commission-collapse" value="mipInfo">
                <el-collapse-item title="流程信息" name="mipInfo">
                    <div class="header-operation">
                        <lots-button size="mini" type="primary" v-if="!['abandoned'].includes(detailDataLocal.statusCode + '')"
                            @click="submitMip" :loading="btnloading" class="bigData-btn-commission-flow-approve">
                            提交审批
                        </lots-button>
                    </div>
                    <iframe class="ifr" :src="mipUrl" v-if="!btnloading" />
                </el-collapse-item>
            </el-collapse>
        </div>
    </paper>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import bigDataLog from '@/utils/bigDataLog.js';
import CollapseInfos from '@/modules/mdm/views/contractModules/components/collapseInfos/CollapseInfos.vue';
import { getCommissionDetail, saveCommission } from '@mdm/api/customer/revenueForecast.js';
import { filePreview } from '@/utils/filePreview.js';
import { getNodesAndOperationApi } from '@/modules/mdm/utils/flowUtils.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { Message } from 'element-ui';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import { collapse } from './collapseInfosConfig.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
const mipStatusDisableList = ['approval', 'completed', 'abandoned']; // approval审批中,completed已完成,abandoned已废弃
const { MAGIC_NUMBER } = utils;
export default {
    name: 'commissionFlow',
    components: {
        paper,
        lotsButton,
        CollapseInfos,
        lotsUploadButton
    },
    props: { },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const ctx = getCurrentInstance();
        const detailLoading = ref(false);
        const btnloading = ref(false);
        const saveLoading = ref(false);
        const submitLoading = ref(false);
        const detailDataLocal = ref({
            fdId: '',
            fileList: []
        });
        const pageTitle = ref('');

        const activeCollapses = ref(['basicInfo']);
        const mipUrl = ref('');
        const COLLAPSE = computed(() => {
            const { statusCode, ownerCode } = detailDataLocal.value;
            const isOwner = userCode === ownerCode;
            const canEdit = !mipStatusDisableList.includes(statusCode?.toString()) && isOwner;
            const config = _.cloneDeep(collapse);
            config.forEach((v) => {
                v.formList.forEach((v2) => {
                    if (v2.prop === 'content') {
                        if (canEdit) {
                            v2.type = v2.sourceType || 'input';
                            v2.disabled = false;
                        } else {
                            v2.type = 'custom';
                            v2.disabled = true;
                        }
                    }
                    if (['fileList'].includes(v2.prop)) {
                        v2.disabled = !canEdit;
                    }
                    if (['ownerName', 'approverName', 'todoStartTime', 'todoEndTime', 'statusCode'].includes(v2.prop)) {
                        v2.disabled = true;
                    }
                });
            });
            return config;
        });
        const showBtn = computed(() => {
            const { statusCode, fdId, ownerCode } = detailDataLocal.value;
            const isOwner = userCode === ownerCode;
            const editableStatus = !mipStatusDisableList.includes(statusCode?.toString()) && isOwner;
            return {
                editBtn: editableStatus,
                save: editableStatus && fdId,
                submit: editableStatus && fdId
            };
        });

        const newMip = ref(false);
        const shouldScrollToMip = ref(false);
        const formatData = (data) => {
            const newData = _.cloneDeep(data);
            !newData.fileList && (newData.fileList = []);
            return newData;
        };
        const { userName, userCode } = store.getters.user;
        const currentNodeInfo = ref({});
        const _initData = async () => {
            const { id, relationId, ownerCode } = ctx.$route.query;
            detailLoading.value = true;
            if (id || relationId || ownerCode) {
                try {
                    await getCommissionInfo();
                    const { fdId, mipType, statusCode, todoTitle } = detailDataLocal.value;
                    pageTitle.value = todoTitle || '收入预测待办';
                    if (!fdId) {
                        detailLoading.value = false;
                        handleInfosChange({ form: formatData(detailDataLocal.value) });
                        return;
                    };
                    detailLoading.value = false;
                    currentNodeInfo.value = {
                        mipFlowId: fdId,
                        mipType,
                        mipStatus: statusCode
                    };
                } catch (error) {
                    //
                }
            }
            detailLoading.value = false;
            handleInfosChange({ form: formatData(detailDataLocal.value) });
            if (shouldScrollToMip.value) {
                shouldScrollToMip.value = false;
                const scrollTimer = setTimeout(() => {
                    scrollToHandle();
                    clearTimeout(scrollTimer);
                }, MAGIC_NUMBER.FOUR_HUNDRED);
            }
        };
        const currentAuth = ref(false);
        const isHandleEdit = ref(false);
        const handleInfosChange = async (formObjData = {}) => {
            const { itemSetting, targetForm } = formObjData;
            if (!itemSetting) {
                if (detailDataLocal.value.fdId) {
                    handleCreate();
                    currentAuth.value = await getNodesAndOperationApi({ fdId: detailDataLocal.value.fdId, loginName: userCode });
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate();
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value);
            } else {
                const { fileList } = detailDataLocal.value;
                detailDataLocal.value = Object.assign(
                    {},
                    detailDataLocal.value,
                    formObjData.form,
                    targetForm,
                    { fileList }
                );
            }
        };
        const handleCreate = () => {
            mipUrl.value = '';
            mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.fdId}&fdTemplateKey=CRM_commission&userCode=${userCode}&userName=${userName}`;
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            newMip.value && setTimeout(() => {
                const element = document.getElementsByClassName('commission-flow')[0];
                element.scrollTo(0, MAGIC_NUMBER.TWO_THOUSAND);
                newMip.value = false;
            }, MAGIC_NUMBER.FOUR_HUNDRED);
        };
        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };
        const timer = 1800;
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const times = setTimeout(async () => {
                        _initData();
                        clearTimeout(times);
                    }, timer);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
                btnloading.value = false;
            });
        };
        const prepareApproveParams = (eventData) => {
            const { id, fdId, relationId, ownerCode } = detailDataLocal.value;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/commissionFlow?id=${id}&relationId=${relationId}&ownerCode=${ownerCode}&fdId=${fdId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };
        const handleDraftSubmit = async (params) => {
            try {
                await handleApproveProcess(params);
            } catch (e) {
                btnloading.value = false;
            }
        };
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            btnloading.value = true;
            const params = prepareApproveParams(event.data);
            await handleDraftSubmit(params);
        };
        const submitMip = async () => {
            const content = window;
            content.frames && content.frames.length && content.frames[0]
                && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
            content.frames && content.frames.length && content.frames[1]
                && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value);
            currentTime.value = new Date().getTime();
            store.commit('updateIflowPage', { pageTime: currentTime.value });
        };
        const currentTime = ref('');

        const checkSubmit = () => {
            const data = _.cloneDeep(setupContext.refs.upholdHealder.onsave());
            data.fileList = detailDataLocal.value.fileList;
            if (!data) return false;
            return data;
        };

        const handleSave = () => {
            if (!showBtn.value.editBtn) {
                return {};
            }
            const data = checkSubmit();
            if (!data) {
                return false;
            }
            const params = {
                id: detailDataLocal.value.id,
                content: data.content,
                fileList: detailDataLocal.value.fileList
            };
            saveLoading.value = true;
            return saveCommission(params).then(res => {
                if (+res.code === 0 && res.data) {
                    newMip.value = true;
                    isHandleEdit.value = false;
                    Message.success('保存成功');
                    const timer = setTimeout(() => {
                        _initData(true);
                        clearTimeout(timer);
                    // eslint-disable-next-line no-magic-numbers
                    }, 2000);
                }
            }).finally(() => { saveLoading.value = false; });
        };

        const handleSubmit = async () => {
            if (!showBtn.value.editBtn) {
                return;
            }
            submitLoading.value = true;
            try {
                shouldScrollToMip.value = true;
                const saveRes = await handleSave();
                if (saveRes && +saveRes.code !== 0) {
                    shouldScrollToMip.value = false;
                    return;
                }
                await submitMip();
                scrollToHandle();
            } finally {
                submitLoading.value = false;
            }
        };

        const openMeixin = (form, type) => {
            const mip = type === 'owner' ? form.ownerCode : form.approverCode;
            if (mip) {
                window.location.href = `MeiCloud://Message/?uid=${mip}`;
            }
        };

        const scrollToHandle = () => {
            const elementRules = document.querySelector(`.commission-info`);
            const collapseRules = document.querySelector(`.commission-collapse`);
            if (elementRules && collapseRules) {
                setupContext.root.$nextTick(() => {
                    elementRules.scrollTo({
                        // eslint-disable-next-line no-magic-numbers
                        top: collapseRules.offsetTop - 120,
                        left: 0,
                        behavior: 'smooth'
                    });
                });
            }
        };

        const getCommissionInfo = () => {
            const { id, relationId, ownerCode } = ctx.$route.query;
            if (!id && !relationId && !ownerCode) return;
            isHandleEdit.value = false;
            btnloading.value = true;
            return getCommissionDetail({ id, relationId, ownerCode }).then(res => {
                if (res && +res.code === 0) {
                    detailDataLocal.value = res.data || {};
                }
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value);
            }).catch(() => {
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.refleshPage(detailDataLocal.value);
            }).finally(() => {
                btnloading.value = false;
            });
        };

        const upLoadData = async (form, itemSetting, data) => {
            const { prop } = itemSetting;
            form[prop] = form[prop] ? form[prop] : [];
            if (data && +data.code === 0) {
                form[prop].push({ fileName: data.data.name, fileUrl: data.data.downUrl });
                const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
                if (prop === 'fileList') {
                    if (itemSetting.rule[0].required) {
                        const targetRef = formRefs.find(item => item._props.refName === 'basicForm');
                        targetRef.$refs['basicForm'].validateField(prop);
                    }
                    detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
                    isHandleEdit.value = true;
                }
            }
        };
        let lastUploadClickTime = 0;
        const handleUploadBtnClick = () => {
            const now = Date.now();
            // eslint-disable-next-line no-magic-numbers
            if (now - lastUploadClickTime < 500) return;
            lastUploadClickTime = now;
            bigDataLog.sendDetailMessageByKey('bigData-btn-commission-flow-upload');
        };
        const handleDeleteFile = (form, itemSetting, index) => {
            const { prop } = itemSetting;
            form[prop].splice(index, 1);
            detailDataLocal.value = Object.assign({}, detailDataLocal.value, form);
            const formRefs = setupContext.refs.upholdHealder.$refs.dcForm;
            if (prop === 'fileList' && itemSetting.rule[0].required) {
                const targetRef = formRefs.find(item => item._props.refName === 'basicForm');
                targetRef.$refs['basicForm'].validateField(prop);
            }
            isHandleEdit.value = true;
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.fileUrl,
                fileName: row.fileName
            });
        };
        const handleDownload = async (row) => {
            const url = new URL(row.fileUrl);
            url.searchParams.set('response-content-type', 'application/octet-stream');
            const link = document.createElement('a');
            link.href = url.toString();
            link.download = row.fileName;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            Message.success('下载中');
        };
        const triggerInitData = () => {
            const { id, relationId, ownerCode } = ctx.$route.query;
            if (id === detailDataLocal.value.id && relationId === detailDataLocal.value.relationId && ownerCode === detailDataLocal.value.ownerCode) return;
            detailDataLocal.value = {};
            setupContext.root.$nextTick(() => {
                _initData();
                setupContext.refs.upholdHealder && setupContext.refs.upholdHealder.clearValidate();
            });
        };
        onMounted(() => {
            triggerInitData();
        });
        return {
            COLLAPSE,
            detailLoading,
            btnloading,
            detailDataLocal,
            mipUrl,
            activeCollapses,
            saveLoading,
            submitLoading,
            showBtn,
            pageTitle,
            handleInfosChange,
            submitMip,
            upLoadData,
            handleDeleteFile,
            handlePreview,
            handleDownload,
            handleSave,
            handleSubmit,
            openMeixin,
            handleUploadBtnClick
        };
    }
};
</script>
<style lang="less" scoped>

.commission-flow {
    display: flex;
    flex-direction: column;

    .header-box {
        text-align: center;
        h4 {
            font-size: 20px;
            margin: 0;
            color: #606266;
        }
    }

    .detail-toolBar-resp {
        display: flex;
        justify-content: flex-start;
        padding: 4px 0;
    }

    .commission-flow-detail {
        overflow: auto;

        .upload-demo {
            display: inline-block;
        }

        .down-mould-btn {
            margin-left: 5px;
        }

        .upload-tips {
            display: inline-block;
            margin-left: 10px;
            line-height: 28px;
            font-size: 12px;
            color: #606266;
        }

        .file-infos {
            width: 100%;
            padding: 0 10px 0 0;

            .file-list {
                width: 100%;
                padding: 2px 0 2px 0px;
                display: flex;

                .file-name {
                    &.upload {
                        width: 500px;
                    }

                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;

                    .file-link {
                        color: #4285F5;
                        cursor: pointer;
                    }
                }

                .view-btn,
                .delete-btn {
                    width: 200px;
                    display: flex;

                    a {
                        color: #4285F5;
                    }

                    .el-button:focus,
                    .el-button:hover,
                    .el-button:active,
                    .el-button.is-disabled {
                        outline: none !important;
                        border-color: transparent !important;
                    }
                }
            }
        }

        .el-collapse-item__content {
            padding-bottom: 5px;
        }

        .el-collapse-item__arrow {
            margin: 0 8px 0 5px;
        }

        .el-button.is-disabled.is-plain,
        .el-button.is-disabled.is-plain:focus,
        .el-button.is-disabled.is-plain:hover {
            border-color: #FFF;
        }

        .width-small {
            width: 340px;
        }

        .width-middle {
            width: 500px;
        }

        .width-large {
            width: 1200px;
        }

        .el-col.el-col-23.form-item {
            .el-form-item.el-form-item--mini {
                margin-bottom: 18px;
            }
        }

        .el-collapse-item__header {
            height: 32px;
        }

        .detail-form-collapse {
            padding-right: 10px;
        }

        .score-config-item-box {
            .item-tittle {
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                margin-left: 28px;
            }
        }

        .rating-score-list-box {
            .el-collapse {
                border-bottom: none;

                .el-collapse-item__header {
                    border-bottom: none;
                }

                .el-collapse-item__wrap {
                    border-bottom: none;
                }
            }
        }
    }

    .ifr {
        width: 100%;
        height: 100vh;
        border: none;
    }

    .el-collapse-item__header {
        color: #606266;
        font-size: 14px;
        font-weight: 600;
    }

    .header-operation {
        margin-top: 10px;
    }

    ::v-deep .custom-textarea{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
        width: 100%;
    }

    .user-select-span{
        color: #4285F5!important;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
    }
}

.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}

.my-tooltip-box {
    width: 800px;
}
</style>
